// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import { spServiceSessionMasterHeaders } from "../components/HeaderAttribute";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import SPServiceSessionPopup from "../popup-containers/SPServicesSessionPopup";
import * as XLSX from "sheetjs-style";
import toast from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { useLocation, useNavigate } from "react-router-dom";
import GridPage from "../components/GridPage";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
const SplServicesTrans = () => {
  const location1 = useLocation();
  //User Capability State data start
  const { userProfileState } = useUserCapability();
  const userVsCapability = userProfileState.userVsCapability;
  const userProfileDatas = userProfileState.userProfile;
  const navigate = useNavigate();
  //User Capability State data end;
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [bindSPServices, setBindSPServices] = useState([]);
  const [venue, setVenue] = useState("");
  const [date, setDate] = useState("");
  const [place, setPlace] = useState("");
  const [remarks, setRemarks] = useState("");
  const [spServiceType, setSpServiceType] = useState("");
  const [clientType, setClientType] = useState("");
  const [hcpName, setHCPName] = useState("");
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [other, setOther] = useState("");
  const [total, setTotal] = useState("");
  const [updateButton, setUpdateButton] = useState(false);
  const [submitButton, setSubmitButton] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  const [bindState, setBindStatesDD] = useState([]);
  const [bindLocation, setBindLocationDD] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);

  const [state, setState] = useState("");
  const [area, setArea] = useState("");
  const [sdp, setSdp] = useState("");
  const [location, setLocation] = useState("");
  const [mstOrganizationId, setMstOrganizationId] = useState("");
  const [dateTimeError, setDateTimeError] = useState("");
  const [venueError, setVenueError] = useState("");
  const [spServiceTopicError, setSPServiceTopicError] = useState("");
  const [hcpNameError, setHCPNameError] = useState("");
  const [stateError, setStateError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [sdpError, setSdpError] = useState("");
  const [areaError, setAreaError] = useState("");
  const [totalError, setTotalError] = useState("");

  const [dateError, setDateError] = useState("");
  const [placeError, setPlaceError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [blockError, setBlockError] = useState("");
  const [cityVillageError, setCityVillageError] = useState("");
  const [spServiceTypeError, setSpServiceTypeError] = useState("");
  const [clientTypeError, setClientTypeError] = useState("");

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // Set the initial items per page
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [editMstSPServicesId, setEditMstSPServicesId] = useState("");
  const [spServiceData2, setSPServiceData2] = useState({});

  const [spServices, setSPServicesData] = useState("");

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bindHcpName, setBindHcpName] = useState([]);
  const [bindSPSType, setBindSPSType] = useState([]);
  const [bindClientType, setBindClientType] = useState([]);
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [cityVillage, setCityVillage] = useState("");
  const [bindBlock, setBindBlock] = useState([]);
  const [getBlockDatas, setGetBlockDatas] = useState([]);
  const [getCityDatas, setGetCityDatas] = useState([]);
  const [bindCityVillage, setBindCityVillage] = useState([]);

  const [bindDistrict, setBindDistrict] = useState([]);
  const [getDistrictDatas, setGetDistrictDatas] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (userProfileDatas && userProfileDatas.length > 0) {
      initPageData(userProfileDatas[0]);
    }
  }, [userProfileDatas]);

  const initPageData = async (user) => {
    setIsLoading(true);
    try {
      // Run both in parallel
      await Promise.all([
        fetchData(), // dropdowns
        BindClientGridData(user), // client grid
      ]);
    } catch (error) {
      console.error("Error initializing page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const BindClientGridData = async (user) => {
    if (!user) return;
    try {
      const Binddata = {
        mstOrganizationStructureId: user.MstOrganizationId,
        mstBranchId: user.MstLocationId,
        mstSdpId: user.MstSDPId || 0,
        mstUserId: user.MstUserId,
        mstRoleId: user.MstRoleId,
      };

      const response = await BindPostAPI(
        [Binddata],
        "SPServiceTransAPI/BindSPServicesAPI"
      );

      setBindSPServices(response?.data?.Table || []);
    } catch (error) {
      console.error("Error fetching client grid data:", error);
      setBindSPServices([]);
    }
  };


  const spServicesHeader = [
    { title: "S.No.", key: "sno", width: 10 },
    { title: "MstSPServicesId", key: "MstSPServicesId", width: 20 },
    { title: "Date", key: "Date", width: 18 },

    // State
    { title: "State_en", key: "StateName_en", width: 25 },
    // { title: "State_ta", key: "StateName_ta", width: 25 },
    // { title: "State_hi", key: "StateName_hi", width: 25 },
    // { title: "State_mr", key: "StateName_mr", width: 25 },
    // { title: "State_gu", key: "StateName_gu", width: 25 },
    // { title: "State_kn", key: "StateName_kn", width: 25 },
    // { title: "State_ml", key: "StateName_ml", width: 25 },
    // { title: "State_te", key: "StateName_te", width: 25 },
    // { title: "State_bn", key: "StateName_bn", width: 25 },
    // { title: "State_or", key: "StateName_or", width: 25 },

    // Location
    { title: "Location_en", key: "LocationName_en", width: 30 },
    // { title: "Location_ta", key: "LocationName_ta", width: 30 },
    // { title: "Location_hi", key: "LocationName_hi", width: 30 },
    // { title: "Location_mr", key: "LocationName_mr", width: 30 },
    // { title: "Location_gu", key: "LocationName_gu", width: 30 },
    // { title: "Location_kn", key: "LocationName_kn", width: 30 },
    // { title: "Location_ml", key: "LocationName_ml", width: 30 },
    // { title: "Location_te", key: "LocationName_te", width: 30 },
    // { title: "Location_bn", key: "LocationName_bn", width: 30 },
    // { title: "Location_or", key: "LocationName_or", width: 30 },

    // SDP
    { title: "SDP_en", key: "SDP_en", width: 25 },
    // { title: "SDP_ta", key: "SDP_ta", width: 25 },
    // { title: "SDP_hi", key: "SDP_hi", width: 25 },
    // { title: "SDP_mr", key: "SDP_mr", width: 25 },
    // { title: "SDP_gu", key: "SDP_gu", width: 25 },
    // { title: "SDP_kn", key: "SDP_kn", width: 25 },
    // { title: "SDP_ml", key: "SDP_ml", width: 25 },
    // { title: "SDP_te", key: "SDP_te", width: 25 },
    // { title: "SDP_bn", key: "SDP_bn", width: 25 },
    // { title: "SDP_or", key: "SDP_or", width: 25 },

    // Area
    { title: "Area_en", key: "AreaName_en", width: 25 },
    // { title: "Area_ta", key: "AreaName_ta", width: 25 },
    // { title: "Area_hi", key: "AreaName_hi", width: 25 },
    // { title: "Area_mr", key: "AreaName_mr", width: 25 },
    // { title: "Area_gu", key: "AreaName_gu", width: 25 },
    // { title: "Area_kn", key: "AreaName_kn", width: 25 },
    // { title: "Area_ml", key: "AreaName_ml", width: 25 },
    // { title: "Area_te", key: "AreaName_te", width: 25 },
    // { title: "Area_bn", key: "AreaName_bn", width: 25 },
    // { title: "Area_or", key: "AreaName_or", width: 25 },

    // Venue
    { title: "Venue_en", key: "Venue_en", width: 35 },
    { title: "Venue_ta", key: "Venue_ta", width: 35 },
    { title: "Venue_hi", key: "Venue_hi", width: 35 },
    { title: "Venue_mr", key: "Venue_mr", width: 35 },
    { title: "Venue_gu", key: "Venue_gu", width: 35 },
    { title: "Venue_kn", key: "Venue_kn", width: 35 },
    { title: "Venue_ml", key: "Venue_ml", width: 35 },
    { title: "Venue_te", key: "Venue_te", width: 35 },
    { title: "Venue_bn", key: "Venue_bn", width: 35 },
    { title: "Venue_or", key: "Venue_or", width: 35 },

    // District
    { title: "District_en", key: "District_en", width: 25 },
    // { title: "District_ta", key: "District_ta", width: 25 },
    // { title: "District_hi", key: "District_hi", width: 25 },
    // { title: "District_mr", key: "District_mr", width: 25 },
    // { title: "District_gu", key: "District_gu", width: 25 },
    // { title: "District_kn", key: "District_kn", width: 25 },
    // { title: "District_ml", key: "District_ml", width: 25 },
    // { title: "District_te", key: "District_te", width: 25 },
    // { title: "District_bn", key: "District_bn", width: 25 },
    // { title: "District_or", key: "District_or", width: 25 },

    // Block
    { title: "Block_en", key: "Block_en", width: 25 },
    // { title: "Block_ta", key: "Block_ta", width: 25 },
    // { title: "Block_hi", key: "Block_hi", width: 25 },
    // { title: "Block_mr", key: "Block_mr", width: 25 },
    // { title: "Block_gu", key: "Block_gu", width: 25 },
    // { title: "Block_kn", key: "Block_kn", width: 25 },
    // { title: "Block_ml", key: "Block_ml", width: 25 },
    // { title: "Block_te", key: "Block_te", width: 25 },
    // { title: "Block_bn", key: "Block_bn", width: 25 },
    // { title: "Block_or", key: "Block_or", width: 25 },

    // City
    { title: "City_en", key: "City_en", width: 25 },
    // { title: "City_ta", key: "City_ta", width: 25 },
    // { title: "City_hi", key: "City_hi", width: 25 },
    // { title: "City_mr", key: "City_mr", width: 25 },
    // { title: "City_gu", key: "City_gu", width: 25 },
    // { title: "City_kn", key: "City_kn", width: 25 },
    // { title: "City_ml", key: "City_ml", width: 25 },
    // { title: "City_te", key: "City_te", width: 25 },
    // { title: "City_bn", key: "City_bn", width: 25 },
    // { title: "City_or", key: "City_or", width: 25 },

    // Healthcare Provider
    { title: "Healthcare_en", key: "HealthcareProviderName_en", width: 40 },
    // { title: "Healthcare_ta", key: "HealthcareProviderName_ta", width: 40 },
    // { title: "Healthcare_hi", key: "HealthcareProviderName_hi", width: 40 },
    // { title: "Healthcare_mr", key: "HealthcareProviderName_mr", width: 40 },
    // { title: "Healthcare_gu", key: "HealthcareProviderName_gu", width: 40 },
    // { title: "Healthcare_kn", key: "HealthcareProviderName_kn", width: 40 },
    // { title: "Healthcare_ml", key: "HealthcareProviderName_ml", width: 40 },
    // { title: "Healthcare_te", key: "HealthcareProviderName_te", width: 40 },
    // { title: "Healthcare_bn", key: "HealthcareProviderName_bn", width: 40 },
    // { title: "Healthcare_or", key: "HealthcareProviderName_or", width: 40 },

    // Service
    { title: "Special Service Session Type_en", key: "SPServicesName_en", width: 40 },
    { title: "Special Service Session Type_ta", key: "SPServicesName_ta", width: 40 },
    { title: "Special Service Session Type_hi", key: "SPServicesName_hi", width: 40 },
    { title: "Special Service Session Type_mr", key: "SPServicesName_mr", width: 40 },
    { title: "Special Service Session Type_gu", key: "SPServicesName_gu", width: 40 },
    { title: "Special Service Session Type_kn", key: "SPServicesName_kn", width: 40 },
    { title: "Special Service Session Type_ml", key: "SPServicesName_ml", width: 40 },
    { title: "Special Service Session Type_te", key: "SPServicesName_te", width: 40 },
    { title: "Special Service Session Type_bn", key: "SPServicesName_bn", width: 40 },
    { title: "Special Service Session Type_or", key: "SPServicesName_or", width: 40 },

    // Client Type
    { title: "ClientType_en", key: "ClientType_en", width: 25 },
    { title: "ClientType_ta", key: "ClientType_ta", width: 25 },
    { title: "ClientType_hi", key: "ClientType_hi", width: 25 },
    { title: "ClientType_mr", key: "ClientType_mr", width: 25 },
    { title: "ClientType_gu", key: "ClientType_gu", width: 25 },
    { title: "ClientType_kn", key: "ClientType_kn", width: 25 },
    { title: "ClientType_ml", key: "ClientType_ml", width: 25 },
    { title: "ClientType_te", key: "ClientType_te", width: 25 },
    { title: "ClientType_bn", key: "ClientType_bn", width: 25 },
    { title: "ClientType_or", key: "ClientType_or", width: 25 },

    // Counts
    { title: "Male", key: "Male", width: 15 },
    { title: "Female", key: "Female", width: 15 },
    { title: "Other", key: "Other", width: 15 },
    { title: "No. of Beneficiaries", key: "No. of Beneficiaries", width: 25 },

    // Remarks
    { title: "Remarks_en", key: "Remarks_en", width: 40 },
    { title: "Remarks_ta", key: "Remarks_ta", width: 40 },
    { title: "Remarks_hi", key: "Remarks_hi", width: 40 },
    { title: "Remarks_mr", key: "Remarks_mr", width: 40 },
    { title: "Remarks_gu", key: "Remarks_gu", width: 40 },
    { title: "Remarks_kn", key: "Remarks_kn", width: 40 },
    { title: "Remarks_ml", key: "Remarks_ml", width: 40 },
    { title: "Remarks_te", key: "Remarks_te", width: 40 },
    { title: "Remarks_bn", key: "Remarks_bn", width: 40 },
    { title: "Remarks_or", key: "Remarks_or", width: 40 },

    // Created By
    { title: "CreatedBy_en", key: "CreatedBy_en", width: 30 },
    // { title: "CreatedBy_ta", key: "CreatedBy_ta", width: 30 },
    // { title: "CreatedBy_hi", key: "CreatedBy_hi", width: 30 },
    // { title: "CreatedBy_mr", key: "CreatedBy_mr", width: 30 },
    // { title: "CreatedBy_gu", key: "CreatedBy_gu", width: 30 },
    // { title: "CreatedBy_kn", key: "CreatedBy_kn", width: 30 },
    // { title: "CreatedBy_ml", key: "CreatedBy_ml", width: 30 },
    // { title: "CreatedBy_te", key: "CreatedBy_te", width: 30 },
    // { title: "CreatedBy_bn", key: "CreatedBy_bn", width: 30 },
    // { title: "CreatedBy_or", key: "CreatedBy_or", width: 30 },
  ];

  // const handleSPServicesExport = async () => {
  //   try {
  //     const [profile] = userProfileDatas;

  //     const payload = {
  //       mstOrganizationStructureId: profile.MstOrganizationId,
  //       mstBranchId: profile.MstLocationId,
  //       mstSdpId: profile.MstSDPId ?? 0,
  //       mstUserId: profile.MstUserId,
  //       mstRoleId: profile.MstRoleId,
  //     };

  //     const response = await BindPostAPI(
  //       [payload],
  //       "SPServiceTransAPI/BindSPServicesExcelExport"
  //     );

  //     const rows = response?.data?.Table || [];

  //     if (rows.length === 0) {
  //       toast.error("No data available to export", {
  //         duration: 1000,
  //         position: "top-center",
  //       });
  //       return;
  //     }

  //     exportSPServicesData(spServicesHeader, rows);

  //   } catch (error) {
  //     console.error("SP Services Export Error:", error);

  //     toast.error("Failed to export data", {
  //       duration: 1000,
  //       position: "top-center",
  //     });
  //   }
  // };

  const handleSPServicesExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const [profile] = userProfileDatas;

      const payload = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0,
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };

      const response = await BindPostAPI(
        [payload],
        "SPServiceTransAPI/BindSPServicesExcelExport"
      );

      const rows = response?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "SP SERVICES",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_spservices",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "SP SERVICES",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_spservices",
            description: `SP Services Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }

      exportSPServicesData(spServicesHeader, rows);
    } catch (error) {
      console.error("SP Services Export Error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "SP SERVICES",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_spservices",
          description: error?.message || "SP Services Excel export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Failed to export data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportSPServicesData = (headers, rows) => {

    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "SP Services Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = headers.map((column) => ({
      v: column.title,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    /* ================= DATA ================= */
    const dataRows = rows.map((rowData, index) => {

      const isAlternateRow = index % 2 === 1;

      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return headers.map((col) => {

        // Serial Number
        if (col.key === "sno") {
          return {
            v: index + 1,
            s: rowStyle,
          };
        }

        return {
          v: rowData[col.key] ?? "",
          s: rowStyle,
        };
      });
    });

    const wsData = [titleRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = headers.map((col) => ({
      width: col.width || 25,
    }));

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 20 },
      ...Array(rows.length).fill({ hpt: 18 }),
    ];

    /* ================= BORDERS ================= */
    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {

        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });

        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "SP Services");

    XLSX.writeFile(wb, "Service Session.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };
  const fetchData = async () => {
    
    try {
      // First group of APIs (parallel calls)
      const spServiceRes = await BindAPI(
        "SPServiceTransAPI/BindAllMasterSPServicesAPI"
      );

      const {
        Table = [],
        Table1 = [],
        Table2 = [],
        Table3 = [],
        Table5 = [],
        Table6 = [],
        Table7 = [],
        Table8 = [],
        Table9 = [],
        Table10 = [],
      } = spServiceRes.data || {};

      setBindStatesDD(
        Table.map((m) => ({
          value: m.MstStateId,
          label: m.StateName_en,
        }))
      );
      setGetLocationDatas(Table1);
      setGetAreaDatas(Table2);
      setGetSDPDatas(Table3);
      setBindSPSType(
        Table5.map((m) => ({
          value: m.MstSpServicesTopicsId,
          label: m.SPServicesName_en,
        }))
      );

      setBindClientType(
        Table6.map((m) => ({
          value: m.MstSPClientTypeId,
          label: m.ClientType_en,
        }))
      );

      setGetDistrictDatas(Table7);
      setGetBlockDatas(Table8);
      setGetCityDatas(Table9);

      const locationId = userProfileDatas[0]?.MstLocationId;

      setBindHcpName(
        Table10
          .filter(m =>
            locationId == null || locationId === 0
              ? true
              : m.MstLocationId === locationId
          )
          .map(m => ({
            value: m.MstHealthCareProviderId,
            label: m.HealthcareProviderName_en,
          }))
      );

      // setBindHcpName(
      //   Table10
      //     .filter(m => m.MstLocationId == userProfileDatas[0].MstLocationId)
      //     .map(m => ({
      //       value: m.MstHealthCareProviderId,
      //       label: m.HealthcareProviderName_en,
      //     }))
      // );

    } catch (error) {
      console.error("Error fetching dropdowns:", error);
    }
  };

  // Generic function to bind dependent dropdown
  const bindDropdown = (
    sourceArray,
    key,
    selectedValue,
    valueField,
    labelField,
    setState
  ) => {
    if (!sourceArray || sourceArray.length === 0) return setState([]);

    const filtered = sourceArray.filter((item) => item[key] === selectedValue);
    const mapped = filtered.map((item) => ({
      value: item[valueField],
      label: item[labelField],
    }));

    setState(mapped);
  };

  // Example usage in useEffect
  useEffect(() => {
    bindDropdown(
      getLocationDatas,
      "MstStateId",
      state,
      "MstLocationId",
      "LocationName_en",
      setBindLocationDD
    );
  }, [state, getLocationDatas]);

  useEffect(() => {
    bindDropdown(
      getSDPDatas,
      "MstLocationId",
      location,
      "MstSDPId",
      "SDP_en",
      setBindSDP
    );
  }, [location, getSDPDatas]);

  useEffect(() => {
    bindDropdown(
      getAreaDatas,
      "MstSDPId",
      sdp,
      "MstAreaId",
      "AreaName_en",
      setBindAreaDD
    );
  }, [sdp, getAreaDatas]);

  useEffect(() => {
    bindDropdown(
      getDistrictDatas,
      "MstStateId",
      state,
      "MstDistrictId",
      "District_en",
      setBindDistrict
    );
  }, [state, getDistrictDatas]);

  useEffect(() => {
    bindDropdown(
      getBlockDatas,
      "MstDistrictId",
      district,
      "MstBlockId",
      "Block_en",
      setBindBlock
    );
  }, [district, getBlockDatas]);

  useEffect(() => {
    bindDropdown(
      getCityDatas,
      "MstBlockId",
      block,
      "MstCityId",
      "City_en",
      setBindCityVillage
    );
  }, [block, getCityDatas]);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  const handleClose = () => {
    setpopUpOpen(false);
  };
  const HandleBindSPService = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setSPServicesData(bindSPServices[rowIndex]);
    const ESPID = bindSPServices[rowIndex].MstSPServicesId;
    setEditMstSPServicesId(ESPID);
    let SPDate = "";
    var SDate = bindSPServices[rowIndex]?.SPDateTime; // Add nullish coalescing operator
    if (SDate !== null && SDate !== undefined) {
      SPDate = SDate.split("T")[0];
    } else {
      SPDate = "";
    }
    const StateRowData = bindSPServices[rowIndex];
    const StateInfo = bindState.find(
      (SD) => SD.value === StateRowData.MstStateId
    );
    const setStateData = {
      value: StateRowData.MstStateId,
      label: StateInfo ? StateInfo.label : "Unknown",
    };
    setState(setStateData.value);
    const locationRowData = bindSPServices[rowIndex];
    const locationInfo = getLocationDatas.find(
      (SD) => SD.MstLocationId === locationRowData.MstLocationId
    );
    const setLocationData = {
      value: locationRowData.MstLocationId,
      label: locationInfo ? locationInfo.LocationName_en : "Unknown",
    };
    setLocation(setLocationData.value);
    const sdpRowData = bindSPServices[rowIndex];
    const sdpInfo = getSDPDatas.find(
      (SD) => SD.MstSDPId === sdpRowData.MstSDPId
    );
    const setSdpData = {
      value: sdpRowData.MstSDPId,
      label: sdpInfo ? sdpInfo.SDP_en : "Unknown",
    };
    setSdp(setSdpData.value);
    const areaRowData = bindSPServices[rowIndex];
    const areaInfo = getAreaDatas.find(
      (SD) => SD.MstAreaId === areaRowData.MstAreaId
    );
    const setAreaData = {
      value: areaRowData.MstAreaId,
      label: areaInfo ? areaInfo.AreaName_en : "Unknown",
    };
    setArea(setAreaData.value);
    const districtRowData = bindSPServices[rowIndex];
    const districtInfo = getDistrictDatas.find(
      (SD) => SD.MstDistrictId === districtRowData.DistrictId
    );
    const setDistrictData = {
      value: districtRowData.DistrictId,
      label: districtInfo ? districtInfo.District_en : "Unknown",
    };
    setDistrict(setDistrictData.value);
    const blockRowData = bindSPServices[rowIndex];
    const blockInfo = getBlockDatas.find(
      (SD) => SD.MstBlockId === blockRowData.BlockId
    );
    const setBlockData = {
      value: blockRowData.BlockId,
      label: blockInfo ? blockInfo.Block_en : "Unknown",
    };
    setBlock(setBlockData.value);
    const cityVillageRowData = bindSPServices[rowIndex];
    const cityVillageInfo = getCityDatas.find(
      (SD) => SD.MstCityId === cityVillageRowData.CityVillageId
    );
    const setCityVillageData = {
      value: cityVillageRowData.CityVillageId,
      label: cityVillageInfo ? cityVillageInfo.City_en : "Unknown",
    };
    setCityVillage(setCityVillageData.value);
    const setSpServiceType = {
      value: bindSPServices[rowIndex].SPServiceType,
      label: bindSPServices[rowIndex].SPServicesName_en,
    };
    const setClientType = {
      value: bindSPServices[rowIndex].MstSPClientTypeId,
      label: bindSPServices[rowIndex].ClientType_en,
    };

    const SPServiceData2 = [
      SPDate,
      setStateData,
      setLocationData,
      setSdpData,
      setAreaData,
      setDistrictData,
      setBlockData,
      setCityVillageData,
      setSpServiceType,
      setClientType,
    ];
    setSPServiceData2(SPServiceData2);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setSubmitButton(true);
    setUpdateButton(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setMstOrganizationId(userProfileDatas[0].MstOrganizationId);
    setSdp(userProfileDatas[0].MstSDPId ?? 0);
    setState(userProfileDatas[0].MstStateId);
    setLocation(userProfileDatas[0].MstLocationId);
  };

  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    clear();
    setSubmitBtnDisabled(false);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    // Refresh data
    if (userProfileDatas && userProfileDatas.length > 0) {
      try {
        await BindClientGridData(userProfileDatas[0]); // safer: pass first user only
      } catch (error) {
        console.error("Error reloading client grid:", error);
      } finally {
        setIsLoading(false);
      }
    }
    setIsLoading(false);
  };

  const clear = () => {
    setMstOrganizationId("");
    setVenue("");
    setRemarks("");
    setSpServiceType("");
    setHCPName("");
    setState("");
    setArea("");
    setSdp("");
    setLocation("");
    setClientType("");
    setMale("");
    setFemale("");
    setOther("");
    setTotal("");
    setDateTimeError("");
    setVenueError("");
    setSPServiceTopicError("");
    setHCPNameError("");
    setStateError("");
    setLocationError("");
    setSdpError("");
    setAreaError("");
    setTotalError("");
    setPlace("");
    setDistrict("");
    setBlock("");
    setCityVillage("");
    setDateError("");
    setPlaceError("");
    setDistrictError("");
    setBlockError("");
    setCityVillageError("");
    setSpServiceTypeError("");
    setClientTypeError("");
    setMale();
    setFemale();
    setOther();
    setTotal();
  };
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
    if (Array.isArray(userVsCapability) && userVsCapability.length > 0) {
    }
  }, [navigate, userVsCapability]);
  const handleEdit = (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    const ESPID = bindSPServices[rowIndex].MstSPServicesId;
    setEditMstSPServicesId(ESPID);
    var SDate = bindSPServices[rowIndex]?.SPDateTime; // Add nullish coalescing operator
    if (SDate !== null && SDate !== undefined) {
      const SPDate = SDate.split("T")[0];
      setDate(SPDate);
    } else {
      setDate("");
    }
    setState(bindSPServices[rowIndex].MstStateId);
    setLocation(bindSPServices[rowIndex].MstLocationId);
    setSdp(bindSPServices[rowIndex].MstSDPId);
    setArea(bindSPServices[rowIndex].MstAreaId);
    setDistrict(bindSPServices[rowIndex].DistrictId);
    setBlock(bindSPServices[rowIndex].BlockId);
    setCityVillage(bindSPServices[rowIndex].CityVillageId);
    setMale(bindSPServices[rowIndex].Male);
    setFemale(bindSPServices[rowIndex].Female);
    setOther(bindSPServices[rowIndex].Other);
    setTotal(bindSPServices[rowIndex].Total);
    setHCPName(bindSPServices[rowIndex].MstHealthCareProviderId);
    setSpServiceType(bindSPServices[rowIndex].SPServiceType);
    setClientType(bindSPServices[rowIndex].MstSPClientTypeId);
    setVenue(bindSPServices[rowIndex].Venue_en);
    setPlace(bindSPServices[rowIndex].Place_en);

    setRemarks(bindSPServices[rowIndex].Remarks_en);
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    const createdBy = sessionStorage.getItem("createdBy");
    if (flag == 1 || flag == 2) {
      // validation start
      const dateValidation = date ? "" : "Enter DOB";
      setDateError(dateValidation);

      const stateValidate = state ? "" : "Enter State";
      setStateError(stateValidate);

      const locationValidate = location ? "" : "Enter Branch/Project";
      setLocationError(locationValidate);

      const sdpValidate = sdp ? "" : "Select a SDP";
      setSdpError(sdpValidate);

      const areaValidate = area ? "" : "Select a Area";
      setAreaError(areaValidate);

      const venueValidation = venue.trim() ? "" : "Enter Venue";
      setVenueError(venueValidation);

      const districtValidate = district ? "" : "Select a District";
      setDistrictError(districtValidate);

      const blockValidate = block ? "" : "Select a Block";
      setBlockError(blockValidate);

      const totalValidate = total ? "" : "Enter No. of Beneficiaries";
      setTotalError(totalValidate);

      const cityVillageValidate = cityVillage ? "" : "Select a City/Village";
      setCityVillageError(cityVillageValidate);

      const hcpNameValidation = hcpName
        ? ""
        : "Select a Healthcare Provider Name";

      setHCPNameError(hcpNameValidation);

      const spServiceTypeValidation = spServiceType
        ? ""
        : "Select a Special Service Session Type";
      setSpServiceTypeError(spServiceTypeValidation);

      const clientTypeValidation = clientType ? "" : "Select a Client Type";
      setClientTypeError(clientTypeValidation);

      if (
        dateValidation ||
        stateValidate ||
        locationValidate ||
        sdpValidate ||
        areaValidate ||
        venueValidation ||
        districtValidate ||
        blockValidate ||
        cityVillageValidate ||
        hcpNameValidation ||
        spServiceTypeValidation ||
        clientTypeValidation ||
        totalValidate
      ) {
        setIsOpen(true);
      }

      if (
        !dateValidation &&
        !stateValidate &&
        !locationValidate &&
        !sdpValidate &&
        !areaValidate &&
        !venueValidation &&
        !districtValidate &&
        !blockValidate &&
        !cityVillageValidate &&
        !hcpNameValidation &&
        !spServiceTypeValidation &&
        !clientTypeValidation &&
        !totalValidate
      ) {
        setIsOpen(false);
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];

        const translatedvenueTexts = [];
        const translatedremarksTexts = [];

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(venue, i);
          translatedvenueTexts.push(
            translateText.data.data.translations[0].translatedText
          );
        }

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(remarks, i);
          translatedremarksTexts.push(
            translateText.data.data.translations[0].translatedText
          );
        }

        const data = {
          mstSPServicesId: editMstSPServicesId ? editMstSPServicesId : 0,
          date: date,

          mstStateId: state,
          mstLocationId: location,
          mstSDPId: sdp,
          mstAreaId: area,
          districtId: district,
          blockId: block,
          cityVillageId: cityVillage,
          venue_en: venue,
          venue_ta: venue,
          venue_hi: venue,
          venue_mr: venue,
          venue_gu: venue,
          venue_ml: venue,
          venue_te: venue,
          venue_kn: venue,
          venue_bn: venue,
          venue_or: venue,
          venue_ta: translatedvenueTexts[0],
          venue_hi: translatedvenueTexts[1],
          venue_mr: translatedvenueTexts[2],
          venue_gu: translatedvenueTexts[3],
          venue_ml: translatedvenueTexts[4],
          venue_te: translatedvenueTexts[5],
          venue_kn: translatedvenueTexts[6],
          venue_bn: translatedvenueTexts[7],
          venue_or: translatedvenueTexts[8],
          mstHealthCareProviderId: hcpName,
          spServiceType: spServiceType,
          clientType: clientType,
          male: male ? male : 0,
          female: female ? female : 0,
          other: other ? other : 0,
          total: total ? total : 0,
          remarks_en: remarks,
          remarks_ta: translatedremarksTexts[0],
          remarks_hi: translatedremarksTexts[1],
          remarks_mr: translatedremarksTexts[2],
          remarks_gu: translatedremarksTexts[3],
          remarks_ml: translatedremarksTexts[4],
          remarks_te: translatedremarksTexts[5],
          remarks_kn: translatedremarksTexts[6],
          remarks_bn: translatedremarksTexts[7],
          remarks_or: translatedremarksTexts[8],
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "SPServiceTransAPI/IUDSPServices"
        );
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Special Services Session added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Special Services Session data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Special Services Session updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Special Services Session data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = {
        mstSPServicesId: bindSPServices[items].MstSPServicesId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "SPServiceTransAPI/IUDSPServices");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Special Services Session data deleted successfully 🗑️",
            1000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to delete Special Services Session data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Special Services Session data blocked successfully 🚫",
            1000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to block Special Services Session data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Special Services Session data unblocked successfully ✅",
            1000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to unblock Special Services Session data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    const hours = currentDate.getHours().toString().padStart(2, "0");
    const minutes = currentDate.getMinutes().toString().padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    setDate(formattedDateTime);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setDate(formattedDate);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const totalChilds =
      (parseInt(male, 10) || 0) +
      (parseInt(female, 10) || 0) +
      (parseInt(other, 10) || 0);
    setTotal(totalChilds > 0 ? totalChilds : ""); // Set total only if greater than 0
  }, [male, female, other]);

  useEffect(() => {
    if (location1.pathname == "/spserviceevent") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location1, userProfileDatas]);

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={`Service Session`}
          header={spServiceSessionMasterHeaders}
          records={bindSPServices}
          handleEdit={handleEdit}
          handleAction={HandleBindSPService}
          handleExportBtn={true}
          handleExport={handleSPServicesExport}
          showAdd={showadd}
          blockView={true}
        />
      )}

      {visibleAdd && (
        <div class="w-full ">
          <div class=" border-black  ">
            <div class="text-black text-2xl font-bold my-2">
              <h3 class="mb-4 text-xl font-medium text-gray-900 ">
                {addScreenTitle && (
                  <div class={mainTable.addScreenTitle}>
                    {`Service Session - Add`}
                  </div>
                )}

                {updateScreenTitle && (
                  <div class={mainTable.addScreenTitle}>
                    {`Service Session - Edit`}
                  </div>
                )}
              </h3>
            </div>
          </div>

          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form class="space-y-6" action="#">
                <div className={mainTable.grid3}>
                  <div>
                    <InputText
                      inputType="date"
                      title="Date"
                      name="date"
                      max={new Date().toISOString().split("T")[0]}
                      classStar={"text-red-500"}
                      content={date}
                      controlFunc={(e) => {
                        setDate(e.target.value);
                      }}
                      controlFuncBlur={(e) => {
                        setDate(e.target.value);
                        setDateError(date ? "" : "Please Select Date");
                      }}
                    />
                    {dateError && <span class="text-red-500">{dateError}</span>}
                  </div>

                  <div>
                    <AutoDropDown
                      title="State"
                      options={bindState}
                      classStar="text-red-500"
                      Class="p-0"
                      placeholder="Select"
                      name="state"
                      selectedOption={bindState.find((x) => x.value == state)}
                      disabled={mstOrganizationId == 1 ? false : true}
                      controlFunc={(value) => {
                        setLocation("");
                        setSdp("");
                        setArea("");
                        setDistrict("");
                        setBlock("");
                        setCityVillage("");
                        setState(value.value);
                        setStateError(value ? "" : "Select a State");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select a State");
                      }}
                    />
                    {stateError && (
                      <span className="text-red-500">{stateError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Branch/Project"
                      options={bindLocation}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="state"
                      selectedOption={bindLocation.find(
                        (x) => x.value == location
                      )}
                      disabled={mstOrganizationId == 1 ? false : true}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setSdp("");
                        setArea("");
                        setLocation(value.value);
                        setLocationError(
                          value ? "" : "Select a Branch/Project"
                        );
                      }}
                      controlFuncBlur={() => {
                        setLocationError(
                          location ? "" : "Select a Branch/Project"
                        );
                      }}
                    />
                    {locationError && (
                      <span className="text-red-500">{locationError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      classStar="text-red-500"
                      title="S.D.P"
                      options={bindSDP}
                      placeholder="Select"
                      disabled={userProfileDatas[0].MstOrganizationId == 3}
                      name="S.D.P"
                      selectedOption={
                        sdp ? bindSDP.find((x) => x.value == sdp) : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setArea("");
                        setSdp(value.value);
                        setSdpError(value ? "" : "Select a SDP");
                      }}
                      controlFuncBlur={() => {
                        setSdpError(sdp ? "" : "Select a SDP");
                      }}
                    />
                    {sdpError && (
                      <span className="text-red-500">{sdpError}</span>
                    )}

                  </div>
                  <div>
                    <AutoDropDown
                      title="Area"
                      options={bindArea}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="state"
                      selectedOption={
                        area ? bindArea.find((x) => x.value == area) : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setArea(value.value);
                        setAreaError(value ? "" : "Select a Area");
                      }}
                      controlFuncBlur={() => {
                        setAreaError(area ? "" : "Select a Area");
                      }}
                    />
                    {areaError && (
                      <span className="text-red-500">{areaError}</span>
                    )}
                  </div>

                  <div>
                    <InputText
                      inputType="text"
                      title="Venue"
                      name="venue"
                      maxLength={100}
                      content={venue}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setVenue(value);
                        setVenueError(
                          value.trim().length > 0
                            ? /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())
                              ? ""
                              : "Only alphabet and single space between words allowed"
                            : "Enter Venue"
                        );
                      }}
                      classStar={"text-red-500"}
                      controlFuncBlur={(e) => {
                        const trimmedVenue = e.target.value.trim();
                        setVenue(trimmedVenue);
                        setVenueError(
                          trimmedVenue.length > 0
                            ? /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(trimmedVenue) // No leading, trailing, or consecutive spaces
                              ? ""
                              : "Only alphabet and single space between words allowed"
                            : "Enter Venue"
                        );
                      }}
                    />
                    {venueError && (
                      <span class="text-red-500">{venueError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="District"
                      classStar="text-red-500"
                      options={bindDistrict}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindDistrict.find(
                        (x) => x.value == district
                      )}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setBlock("");
                        setCityVillage("");
                        setDistrict(value.value);
                        setDistrictError(value ? "" : "Select a district");
                      }}
                      controlFuncBlur={() => {
                        setDistrictError(district ? "" : "Select a district");
                      }}
                    />
                    {districtError && (
                      <span className="text-red-500">{districtError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Block"
                      classStar="text-red-500"
                      options={bindBlock}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindBlock.find((x) => x.value == block)}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setCityVillage("");
                        setBlock(value.value);
                        setBlockError(value ? "" : "Select a block");
                      }}
                      controlFuncBlur={() => {
                        setBlockError(block ? "" : "Select a block");
                      }}
                    />
                    {blockError && (
                      <span className="text-red-500">{blockError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="City / Village"
                      classStar="text-red-500"
                      options={bindCityVillage}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindCityVillage.find(
                        (x) => x.value == cityVillage
                      )}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setCityVillage(value.value);
                        setCityVillageError(
                          value ? "" : "Select a City Village"
                        );
                      }}
                      controlFuncBlur={() => {
                        setCityVillageError(
                          cityVillage ? "" : "Select a City Village"
                        );
                      }}
                    />
                    {cityVillageError && (
                      <span className="text-red-500">{cityVillageError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Healthcare Provider Name"
                      classStar="text-red-500"
                      options={bindHcpName}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindHcpName.find(
                        (x) => x.value == hcpName
                      )}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setHCPName(value.value);
                        setHCPNameError(
                          value ? "" : "Select a Healthcare Provider Name"
                        );
                      }}
                      controlFuncBlur={() => {
                        setHCPNameError(
                          hcpName ? "" : "Select a Healthcare Provider Name"
                        );
                      }}
                    />

                    {hcpNameError && (
                      <span class="text-red-500">{hcpNameError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Special Service Session Type"
                      classStar={"text-red-500"}
                      options={bindSPSType}
                      placeholder="Select"
                      name="spServiceType"
                      selectedOption={bindSPSType.find(
                        (x) => x.value == spServiceType
                      )}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setSpServiceType(value.value);
                        setSpServiceTypeError(
                          value ? "" : "Select a Special Service Session Type"
                        );
                      }}
                      controlFuncBlur={() => {
                        setSpServiceTypeError(
                          spServiceType
                            ? ""
                            : "Select a Special Service Session Type"
                        );
                      }}
                    />
                    {spServiceTypeError && (
                      <span className="text-red-500">{spServiceTypeError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Client Type"
                      classStar={"text-red-500"}
                      options={bindClientType}
                      placeholder="Select"
                      name="clientType"
                      selectedOption={bindClientType.find(
                        (x) => x.value == clientType
                      )}
                      Class="custom-class"
                      disabled={false}
                      tabIndex="1"
                      controlFunc={(value) => {
                        setClientType(value.value);
                        setClientTypeError(value ? "" : "Select a Client Type");
                      }}
                      controlFuncBlur={() => {
                        setClientTypeError(
                          clientType ? "" : "Select a Client Type"
                        );
                      }}
                    />
                    {clientTypeError && (
                      <span className="text-red-500">{clientTypeError}</span>
                    )}
                  </div>
                  <div className="col-span-1">
                    <label htmlFor="client_name" class={mainTable.label}>
                      No. of Beneficiaries
                      <span className="text-red-500">*</span>
                    </label>
                    <div className={mainTable.inputGenderClient}>
                      <InputText
                        inputType={"text"}
                        ClassDiv="grid gap-2 grid-cols-2"
                        ClassLabel={mainTable.labelBaseline}
                        Class={mainTable.smallInput}
                        title={"Male"}
                        maxLength={5}
                        name={"male"}
                        content={male}
                        controlFunc={(e) => {
                          const value = e.target.value;
                          const parsedValue = parseInt(value, 10);
                          setMale(isNaN(parsedValue) ? 0 : parsedValue);
                        }}
                      />
                      <InputText
                        inputType={"text"}
                        maxLength={5}
                        ClassDiv="grid gap-2 grid-cols-2"
                        ClassLabel={mainTable.labelBaseline}
                        Class={mainTable.smallInput}
                        title={"Female"}
                        name={"female"}
                        content={female}
                        controlFunc={(e) => {
                          const value = e.target.value;
                          const parsedValue = parseInt(value, 10);
                          setFemale(isNaN(parsedValue) ? 0 : parsedValue);
                        }}
                      />
                      <InputText
                        inputType={"text"}
                        maxLength={5}
                        ClassDiv="grid gap-2 grid-cols-2"
                        ClassLabel={mainTable.labelBaseline}
                        Class={mainTable.smallInput}
                        title={"Other"}
                        name={"other"}
                        content={other}
                        controlFunc={(e) => {
                          const value = e.target.value;
                          const parsedValue = parseInt(value, 10);
                          setOther(isNaN(parsedValue) ? 0 : parsedValue);
                        }}
                      />
                      <InputText
                        inputType={"text"}
                        ClassDiv="grid gap-2 grid-cols-2"
                        ClassLabel={mainTable.labelBaseline}
                        Class={mainTable.smallInput}
                        title={"total"}
                        maxLength={6}
                        name={"total"}
                        content={total}
                        readOnly={true}
                        controlFunc={() => {
                          const totalChilds = male + female + other;
                          setTotal(totalChilds);
                        }}
                      />
                    </div>
                    {totalError && (
                      <span class="text-red-500">{totalError}</span>
                    )}
                  </div>
                  <div className="lg:col-span-3 sm:col-span-1">
                    <TextArea
                      inputType="text"
                      title="Remarks"
                      name="remarks"
                      content={remarks}
                      maxLength={500}
                      controlFunc={(e) => setRemarks(e.target.value)}
                      rows={4}
                    />
                  </div>
                </div>
              </form>
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                handleSubmit={handleSubmit}
                cancel={cancel}
                disabledBtn={submitBtnDisabled ? true : false}
              />
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={HandleBindSPService}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div class="text-xl font-medium text-neutral-700 mx-5 ">
            {viewDetails && `Service Session - View`}
            {deleteDetails && `Service Session - Delete`}
            {blockDetails && `Service Session - Block`}
            {unBlockDetails && `Service Session - Unblock`}
          </div>
          <SPServiceSessionPopup data={spServices} data1={spServiceData2} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default SplServicesTrans;
